module.exports = __webpack_public_path__ + "img/bg.d99d9059.jpg";